// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"4a1239802886626fe355","383":"31c2715f1b7e5a676f75","454":"1cd8bb283c5a65310782"}[chunkId] + ".js";
};